import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { IgDivider, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { profitAnalysis } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

import { AutomaticManagement } from "./AutomaticManagement";
import { ManualManagement } from "./ManualManagement";

export const CogsPanel = () => {
  const { state } = useLocation();
  const theme = useTheme();
  useEffect(() => {
    const el = document.getElementById(state?.targetId);
    if (el) {
      window.scrollTo({
        behavior: "smooth",
        top:
          el.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top +
          750,
      });
    }
  }, [state?.targetId]);
  return (
    <IgPaper>
      <Grid
        container
        direction={"column"}
        rowSpacing={4}
        id={"cogs-management"}
      >
        <Grid item>
          <IgTypography variant="h3" fontWeight={"fontWeightMedium"}>
            Manage COGS With Intelligems{" "}
            <IgTypography
              onClick={() => {
                openNewTab(profitAnalysis, "Profit Analytics");
              }}
              igStyle={"link"}
            >
              Learn more
            </IgTypography>
          </IgTypography>
        </Grid>
        <Grid item>
          <IgDivider />
        </Grid>
        <AutomaticManagement />
        <Grid item>
          <IgDivider />
        </Grid>
        <ManualManagement />
      </Grid>
    </IgPaper>
  );
};
